<template>
	<div class="question-wangeditor" :id="name" :style="{ width: width ? width : '100%' }"></div>
</template>

<script>
import Wangeditor from 'wangeditor';
import Request from '../../../api/request.js';
export default {
	props: ['width', 'height', 'value', 'name', 'option'],
	data() {
		return {
			Wangeditor,
			editor: {}
		};
	},
	created() {},

	mounted() {
		this.editor = new Wangeditor('#' + this.name);
		this.editor.config.onchangeTimeout = 50; //毫秒
		this.editor.config.onchange = html => {
			this.$emit('input', this.editor.txt.html(), this.option);
		};
		// 配置菜单栏，删减菜单，调整顺序
		this.editor.config.menus = ['bold', 'italic', /*'fontSize',*/ 'underline', 'strikeThrough', 'indent', 'lineHeight', 'foreColor', 'list', 'quote', 'image'];
		this.editor.config.height = this.height ? this.height : 300;
		this.editor.config.fontSize = '12px';
		this.editor.config.zIndex = 500;

		if (this.option == 1) {
			this.editor.config.placeholder = '请输入内容';
		} else if (this.option == 2) {
			this.editor.config.placeholder = '请输入答案';
		} else {
			this.editor.config.placeholder = '';
		}
		this.editor.config.fontSizes = {
			'x-small': { name: '10px', value: '1' },
			small: { name: '13px', value: '2' },
			normal: { name: '16px', value: '3' }
		};
		this.editor.config.showFullScreen = false;
		this.uploadImgConfig();
		this.uploadImgHooks();
		this.editor.create();
		this.setHtml(this.value);
		// 实现监听异步value一次
		this.unwatch = this.$watch('value', val => {
			this.setHtml(val);
			this.unwatch();
		});
	},

	methods: {
		// 上传图片配置
		uploadImgConfig() {
			var token = sessionStorage.getItem('token');
			// 配置 server 接口地址
			this.editor.config.uploadImgServer = Request.ajaxUrl + '/Upload/image/type/question-bank';
			// 默认限制图片大小是 5M ，可以自己修改。
			this.editor.config.uploadImgMaxSize = 5 * 1024 * 1024; // 5M
			// 限制图片类型
			this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
			// 一次最多上传 1 个图片
			this.editor.config.uploadImgMaxLength = 1;
			// 上传图片时添加 http 请求的 header
			this.editor.config.uploadImgHeaders = {
				token: token
			};
		},

		// 上传图片回调
		uploadImgHooks() {
			console.log(1);
			var _this = this;
			this.editor.config.uploadImgHooks = {
				// 上传图片之前
				before: function(xhr) {
					console.log(0);
				},
				// 图片上传并返回了结果，图片插入已成功
				success: function(xhr) {
					console.log('success', xhr);
				},
				// 图片上传并返回了结果，但图片插入时出错了
				fail: function(xhr, editor, resData) {
					console.log('富文本图片上传失败-fail', resData);
				},
				// 上传图片出错，一般为 http 请求的错误
				error: function(xhr, editor, resData) {
					console.log('富文本图片上传失败-error', xhr, resData);
				},
				// 上传图片超时
				timeout: function(xhr) {
					_this.$message('图片上传超时');
				},
				// 图片上传并返回了结果，想要自己把图片插入到编辑器中
				// 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
				customInsert: function(insertImgFn, result) {
					// result 即服务端返回的接口
					//console.log('customInsert', result)

					// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
					insertImgFn(result.data);
				}
			};
		},

		setHtml(val) {
			this.editor.txt.html(val);
		},

		getHtml() {
			return this.editor.txt.html();
		},
		sing() {
			this.editor.txt.clear();
		}
	}
};
</script>

<style lang="scss" scoped>
.p {
	font-size: 12px !important;
}
.w-e-text-container-back .placeholder {
	color: #d4d4d4;
	position: absolute;
	font-size: 11pt;
	line-height: 22px;
	left: 10px;
	top: 10px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	z-index: -1;
}
// >>>.w-e-text{
// 	z-index: 9 !important;
// }

// >>>.w-e-toolbar{
// 	z-index: 9 !important;
// }
// >>>.w-e-text-container{
// 	z-index: 9 !important;
// }
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/questionWangeditor.vue